'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_layouts_MainLayout$DisplayName$1() {
}
export { $c_Lapp_layouts_MainLayout$DisplayName$1 as $c_Lapp_layouts_MainLayout$DisplayName$1 };
$c_Lapp_layouts_MainLayout$DisplayName$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_layouts_MainLayout$DisplayName$1.prototype.constructor = $c_Lapp_layouts_MainLayout$DisplayName$1;
/** @constructor */
function $h_Lapp_layouts_MainLayout$DisplayName$1() {
}
export { $h_Lapp_layouts_MainLayout$DisplayName$1 as $h_Lapp_layouts_MainLayout$DisplayName$1 };
$h_Lapp_layouts_MainLayout$DisplayName$1.prototype = $c_Lapp_layouts_MainLayout$DisplayName$1.prototype;
$c_Lapp_layouts_MainLayout$DisplayName$1.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.layouts.-Main-Layout$-Display-Name$1.js.map
